<ion-header mode="ios">
  <ion-toolbar mode="ios">
    <ion-buttons slot="end">
      <app-modal-back-button
        iconSrc="/assets/icon/x-icon-dark.svg"
        [priority]="9998"
      (activated)="onDismiss()"></app-modal-back-button>
    </ion-buttons>
    @if (onSummary$ | async) {
      <ion-title>Review and Submit</ion-title>
    }
  </ion-toolbar>
</ion-header>
@if (slideItems$ | async; as slideItems) {
  <ion-content scroll-y="false">
    <swiper-container #swiperRef init="false">
      @for (slideItem of slideItems; track trackByFn(i, slideItem); let i = $index) {
        <swiper-slide>
          <div #container class="slide-container">
            @if (isQuestionSlide(slideItem.item)) {
              <app-ssqw-form-slide
                [item]="slideItem.item"
                [initialValue]="slideItem.value"
                [questionNumber]="slideItem.questionNumber"
                (status)="onFormSlideStatus($event, i)"
                (ok)="onSlideNext()"
              (inputClicked)="onInputClicked(container, $event)"></app-ssqw-form-slide>
            }
            @if (!isQuestionSlide(slideItem.item)) {
              <app-ssqw-instructions-slide
                [item]="slideItem.item"
              (ok)="onSlideNext()"></app-ssqw-instructions-slide>
            }
          </div>
        </swiper-slide>
      }
      <swiper-slide>
        @if (summary$) {
          <div  class="slide-container">
            <app-ssqw-summary-slide [items$]="summary$" (switchSlide)="onSwitchSlide($event)"></app-ssqw-summary-slide>
          </div>
        }
      </swiper-slide>
    </swiper-container>
    <!-- <swiper #swiper [config]="swiperConfig" [scrollbar]="true" [virtual]="true" (slideChange)="onSlideChanged()">
    <ng-container *ngFor="let slideItem of slideItems; index as i; trackBy: trackByFn">
      <ng-template swiperSlide>
        <div #container class="slide-container">
          <app-ssqw-form-slide
            *ngIf="isQuestionSlide(slideItem.item)"
            [item]="slideItem.item"
            [initialValue]="slideItem.value"
            [questionNumber]="slideItem.questionNumber"
            (status)="onFormSlideStatus($event, i)"
            (ok)="onSlideNext()"
          (inputClicked)="onInputClicked(container, $event)"></app-ssqw-form-slide>
          <app-ssqw-instructions-slide
            *ngIf="!isQuestionSlide(slideItem.item)"
            [item]="slideItem.item"
          (ok)="onSlideNext()"></app-ssqw-instructions-slide>
        </div>
      </ng-template>
    </ng-container>
    <ng-template *ngIf="summary$" swiperSlide>
      <div class="slide-container">
        <app-ssqw-summary-slide [items$]="summary$" (switchSlide)="onSwitchSlide($event)"></app-ssqw-summary-slide>
      </div>
    </ng-template>
  </swiper> -->
</ion-content>
}
@if (footerModel$ | async; as footerModel) {
  <ion-footer mode="ios" #footer topBorder>
    <ion-toolbar>
      <ion-button mode="md" class="nav-button ph-btn-white" [disabled]="footerModel.atStart" (click)="onSlidePrev()">
        <ion-icon slot="icon-only" src="/assets/icon/back-icon-dark.svg"></ion-icon>
      </ion-button>
      <ion-button mode="md" class="nav-button ph-btn-white" [disabled]="footerModel.atEnd" (click)="onSlideNext()">
        <ion-icon class="rotate" slot="icon-only" src="/assets/icon/back-icon-dark.svg"></ion-icon>
      </ion-button>
      @if (footerModel.atEnd) {
        <ion-button
          mode="md"
          slot="end"
          [disabled]="!footerModel.valid"
          class="submit"
          color="secondary"
          (click)="onSubmit(footerModel.submitPayload)">
          SUBMIT
        </ion-button>
      }
    </ion-toolbar>
  </ion-footer>
}
